import { useState } from "react"
import { CampaignFeatureConfig } from "../../interfaces/campaignConfig"
import apiClient from "../../axiosClient"
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material"

export default function StepThreeSend({
    feature,
    inputsState,
    file,
    isValid,
    setSnackbar,
    onSuccess,
}: {
    feature: CampaignFeatureConfig
    inputsState: Record<string, any>
    file: File | null
    isValid: boolean | null
    setSnackbar: (s: { open: boolean; message: string; severity?: 'success' | 'error' | 'info' }) => void
    onSuccess?: () => void
}) {
    const steps = feature.steps;
    const [isSending, setIsSending] = useState(false)

    const send = async () => {
        if (isValid === false) return setSnackbar({ open: true, message: 'Please validate before sending', severity: 'error' })
        setIsSending(true)
        try {
            let form: FormData
            form = feature.buildSendForm(file, inputsState)

            const res = await apiClient.post(feature.sendEndpoint, form, { headers: { 'Content-Type': 'multipart/form-data' } })
            const msg = res.data?.message ?? 'Request accepted'
            setSnackbar({ open: true, message: msg, severity: 'success' })
            // setTimeout ensures we defer reset to prevent component unmount race condition
            if (onSuccess) {
                setTimeout(() => {
                    onSuccess()
                }, 100)
            }

        } catch (err: any) {
            console.error('send err', err)
            const resp = err?.response
            let msg = 'Send failed'
            if (resp?.data) {
                if (typeof resp.data === 'string') msg = resp.data
                else if (resp.data.message) msg = resp.data.message
            } else if (err?.message) msg = err.message
            setSnackbar({ open: true, message: msg, severity: 'error' })
        } finally {
            setIsSending(false)
        }
    }


    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="body2" gutterBottom>Preview</Typography>
            <Box mb={2} sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12 }}>
                {(() => {
                    const entries = Object.entries(inputsState || {})
                    const lines = entries.length
                        ? entries.map(([k, v]) => {
                            // show objects/arrays as compact JSON, primitives as-is
                            const val = (v !== null && typeof v === 'object') ? JSON.stringify(v) : String(v ?? '')
                            return `${k}: ${val}`
                        })
                        : ['(no inputs)']

                    // append file info
                    lines.push(`file: ${file ? file.name : '—'}`)

                    return lines.join('\n')
                })()}
            </Box>


            <Box display="flex" gap={2}>
                <Button variant="contained" onClick={send} disabled={isSending || isValid === false}>
                    {isSending ? <CircularProgress size={18} /> : (steps[steps.length - 1])}
                </Button>
            </Box>
        </Paper>
    )
}